<template>
  <div class="login_container">
    <div class="login_box">
      <div v-show="showClose" style="position: absolute;left: 99%;top: -25px;" @click="onCloseBlur">
        <div class="closes"></div>
      </div>
      <div class="image_box">
        <img src="../assets/register.png" alt=""/>
      </div>
      <div class="header">
        <span @click="headerPassClick" style="margin: 0;font-family: Noto Sans S Chinese !important;"
              :class="headerPass">密码登录</span>
        <span style="margin: 0 22px;font-weight: 100;font-size: 24px !important;">|</span>
        <span @click="headerPhoneClick" style="margin: 0;font-family: Noto Sans S Chinese !important;"
              :class="headerPhone">快捷登录</span>
      </div>
      <hr :class="headerHr" style="width: 40px;
    border: 1px solid #1c50a7;
    margin-block-end: 1em;
    margin-top: 8px;
    padding: 0px;
    margin-bottom: 33px;
    "/>
      <el-form v-show="isActive" label-width="0" class="login_form" :model="from" :rules="login_rules" ref="loginRef">
        <el-form-item prop="username">
          <el-input placeholder="请输入账号/邮箱/手机号" v-model="from.username"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input placeholder="请输入密码" type="password" v-model="from.password"
          ></el-input>
        </el-form-item>
        <el-form-item prop="validate">
          <el-input placeholder="请输入4位验证码" v-model="from.validate" style="border-radius: 3px;width: 279.8px"
          ></el-input>
          <img style="border-radius: 3px;float: right;width: 133.5px;height: 44px" :src="qrcodeUrl" alt="验证码加载失败..."
               @click="getValicode"/>
        </el-form-item>
        <div style="color: #df2525;font-size: 14px;font-family: Noto Sans S Chinese !important;">{{messages}}</div>
        <el-form-item style="margin-bottom: 0;margin-top: -10px;">
          <div style="float: left;cursor:pointer;font-family: Noto Sans S Chinese !important; " @click="resetPassword">忘记密码?</div>
          <div style="float: right;cursor:pointer;color: rgba(27, 79, 167, 1);font-family:Noto Sans S Chinese !important;
font-weight:400;" @click="toRegister">快捷注册
          </div>
        </el-form-item>
        <el-form-item class="login_button">
          <el-button type="primary" @click="submitLoginFrom()">登录</el-button>
        </el-form-item>
        <div style="color: #999999;font-size: 14px;margin-top: 80px;
        font-family: Noto Sans S Chinese !important;text-align: center;">{{ipTitel}}
        </div>
      </el-form>
      <el-form v-show="!isActive" label-width="0" class="login_form" :model="phoneFrom" :rules="phone_login_rules"
               ref="phoneLoginRef">
        <el-form-item prop="phone">
          <el-input placeholder="请输入手机号" v-model="phoneFrom.phone"></el-input>
        </el-form-item>
        <el-form-item prop="validate">
          <el-input placeholder="请输入4位验证码" v-model="phoneFrom.validate" style="width: 279.8px"
          ></el-input>
          <img style="float: right;width: 133.5px;height: 44px" :src="qrcodeUrl" alt="验证码加载失败..."
               @click="getValicode"/>
        </el-form-item>
        <el-form-item prop="phoneValidate">
          <el-input placeholder="请输入6位验证码" v-model="phoneFrom.phoneValidate" style="width: 279.8px"
          ></el-input>
          <div class="timeButton" v-show="Verification" @click="handleTimeClick">获取动态密码</div>
          <div class="timeButtonClick" v-show="!Verification">{{timers}}秒后重新获取</div>
        </el-form-item>
        <div style="color: #df2525;font-size: 14px;font-family: Noto Sans S Chinese !important;">{{messages}}</div>
        <el-form-item style="margin-bottom: 0;margin-top: -10px;">
          <div style="float: left;cursor:pointer;font-family: Noto Sans S Chinese !important;" @click="resetPassword">忘记密码?</div>
          <div style="float: right;cursor:pointer;color: rgba(27, 79, 167, 1);font-family:Noto Sans S Chinese !important;
font-weight:400;" @click="toRegister">快捷注册
          </div>
        </el-form-item>
        <el-form-item class="login_button">
          <el-button type="primary" @click="submitPhoneLoginFrom()">登录</el-button>
        </el-form-item>
        <div style="color: #999999;font-size: 14px;margin-top: 80px;
        font-family: Noto Sans S Chinese !important;text-align: center;">{{ipTitel}}
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  loginRequest,
  valicodeRequest,
  userIpRequest,
  authServiceClient,
  checkPhoneRequest,
  phoneCodeRequest,
  phoneLoginRequest,
  checkUserNameRequest
} from '../tools/auth-api'

export default {
  name: 'Login',
  methods: {
    validatePhoneCode (rule, value, callback) {
      if (!this.isLogin) {
        callback()
        return
      }
      if (value === null || value === undefined || value === '') {
        callback(new Error('请输入手机验证码'))
        return
      }
      if (value.length > 6 || value.length < 6) {
        callback(new Error('请输入6位手机验证码'))
        return
      }
      callback()
    },
    handleTimeClick () {
      this.$refs.phoneLoginRef.validate((valid) => {
        if (!valid) {
          return
        }
        const that = this
        const request = phoneCodeRequest
        request.setCode(this.phoneFrom.validate)
        request.setPhone(this.phoneFrom.phone)
        const CODE_KEY = 'code'
        let metadata
        if (localStorage.getItem(CODE_KEY)) {
          metadata = { [CODE_KEY]: localStorage.getItem(CODE_KEY) }
        } else {
          metadata = {}
        }
        authServiceClient.sendPhoneCode(request, metadata)
          .then(res => {
            if (res.getStatus()) {
              that.messages = ''
              that.Verification = false
              this.auth_timer = setInterval(() => {
                that.timers--
                if (that.timers <= 0) {
                  that.Verification = true
                  that.timers = 60
                  clearInterval(that.auth_timer)
                }
              }, 1000)
              return
            }
            that.getValicode()
            that.messages = '验证码错误'
            that.Verification = true
            that.timers = 60
          }).catch(err => {
            that.getValicode()
            that.messages = '手机验证码发送失败'
            that.Verification = true
            that.timers = 60
          })
      })
    },
    validateName (rule, value, callback) {
      if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        callback(new Error('用户名不能含有汉字'))
        return
      }
      if (/.*[`~!#$^&*()=|{}':;',\[\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]+.*$/.test(value)) {
        callback(new Error('用户名不能包含特殊字符'))
        return
      }
      const request = checkUserNameRequest
      request.setUsername(value)
      authServiceClient.checkUserName(request, null).then(res => {
        if (res.getStatus() === 1) {
          callback(new Error('账号有误'))
          return
        }
        if (res.getStatus() === 3) {
          callback(new Error('账号未注册'))
          return
        }
        if (res.getStatus() === 2) {
          callback(new Error('账号已被冻结'))
          return
        }
        callback()
      }).catch(err => {
        callback(new Error('校验出错'))
      })
    },
    validatePhone (rule, value, callback) {
      const request = checkPhoneRequest
      request.setPhone(value)
      authServiceClient.checkPhone(request, null).then(res => {
        if (res.getStatus() === 1) {
          callback(new Error('手机号有误'))
          return
        }
        if (res.getStatus() === 3) {
          callback(new Error('手机号未注册'))
          return
        }
        if (res.getStatus() === 2) {
          callback(new Error('账号已被冻结'))
          return
        }
        callback()
      }).catch(err => {
        callback(new Error('校验出错'))
      })
    },
    headerPassClick () {
      this.headerPass = 'headerMax'
      this.headerPhone = 'headerMin'
      this.headerHr = 'headerLeft'
      this.isActive = true
    },
    headerPhoneClick () {
      this.headerPass = 'headerMin'
      this.headerPhone = 'headerMax'
      this.headerHr = 'headerRight'
      this.isActive = false
    },
    getUserIp () {
      authServiceClient.getUserIp(userIpRequest).then(res => {
        this.ipTitel = res.getIpTitle()
      }).catch(err => {
      })
    },
    onCloseBlur () {
      parent.window.location.reload()
    },
    resetPassword () {
      this.$router.push('/resetPassword')
    },
    toRegister () {
      this.$router.push('/register')
    },
    getValicode () {
      const CODE_KEY = 'code'
      let metadata
      if (localStorage.getItem(CODE_KEY)) {
        metadata = { [CODE_KEY]: localStorage.getItem(CODE_KEY) }
      } else {
        metadata = {}
      }
      authServiceClient.getValicode(valicodeRequest, metadata).then(res => {
        this.qrcodeUrl = 'data:image/gif;base64,' + res.toObject().valicodeImage
      })
    },
    submitPhoneLoginFrom () {
      this.isLogin = true
      this.$refs.phoneLoginRef.validate((valid) => {
        if (!valid) {
          return
        }
        const request = phoneLoginRequest
        request.setPhone(this.phoneFrom.phone)
        request.setPhoneCode(this.phoneFrom.phoneValidate)
        const TOKEN_KEY = 'token'
        const CODE_KEY = 'code'
        let metadata
        if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }
        } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else {
          metadata = {}
        }
        authServiceClient.phoneLogin(request, metadata).then(res => {
          if (res.getStatus() === 0) {
            this.$message({
              center: true,
              type: 'success',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            })
            if (this.showClose) {
              parent.window.location.reload()
              return
            }
            //this.$router.push('/index')
            window.open( process.env.VUE_APP_INDEX, "_self");
            return
          }
          this.messages = res.getMessage()
          this.getValicode()
          this.isLogin = false
        }).catch(err => {
          if (err && err.code === 5) {
            this.$router.push('/login')
          }
          this.isLogin = false
        })
      })
      this.isLogin = false
    },
    submitLoginFrom () {
      const that = this
      this.$refs.loginRef.validate((valid) => {
        if (!valid) {
          return false
        }
        const request = loginRequest
        request.setUsername(that.from.username)
        request.setPassword(that.from.password)
        request.setValicode(that.from.validate)
        const TOKEN_KEY = 'token'
        const CODE_KEY = 'code'
        let metadata
        if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }
        } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else {
          metadata = {}
        }
        authServiceClient.userLogin(request, metadata).then(res => {
          if (res.getStatus() === 0) {
            that.$message({
              center: true,
              type: 'success',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            })
            if (that.showClose) {
              parent.window.location.reload()
              return
            }
            //that.$router.push('/index')
            window.open( process.env.VUE_APP_INDEX, "_self");
            return
          }
          that.messages = res.getMessage()
          this.getValicode()
        }).catch(err => {
          if (err && err.code === 5) {
            this.$router.push('/login')
          }
        })
      })
    }
  },
  data () {
    return {
      isLogin: false,
      auth_timer: null,
      timers: 60,
      Verification: true,
      isActive: true,
      headerPass: 'headerMax',
      headerPhone: 'headerMin',
      activeName: 'passLogin',
      headerHr: 'headerLeft',
      ipTitel: '',
      showClose: false,
      from: {
        username: '',
        password: '',
        validate: ''
      },
      phoneFrom: {
        phone: '',
        validate: '',
        phoneValidate: ''
      },
      phone_login_rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '请输入合法手机号', trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' }
        ],
        validate: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur' }
        ],
        phoneValidate: [
          { validator: this.validatePhoneCode, trigger: 'blur' }
        ]
      },
      login_rules: {
        username: [
          { required: true, message: '请输入账号/邮箱/手机号', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' },
          { validator: this.validateName, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
        ],
        validate: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur' }
        ]
      },
      qrcodeUrl: 'data:image/gif;base64,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',
      messages: ''
    }
  },
  created () {
    this.showClose = parent.window.location.pathname !== '/login'
    this.getValicode()
    this.getUserIp()
  },
  destroyed () {
    clearInterval(this.auth_timer)
  }
}
</script>

<style lang="less" scoped>
  .timeButton {
    border-radius: 3px;
    cursor: pointer;
    white-space: nowrap;
    padding: 10px 20px;
    border: 0px solid #000;
    width: 94px;
    height: 24px;
    float: right;
    background-color: #efeded;
    font-size: 14px;
    font-weight: 400;
    font-family: Noto Sans S Chinese !important;
    line-height: 1.7;
    text-align: center;
    color: #333333;
  }

  .timeButtonClick {
    border-radius: 3px;
    cursor: pointer;
    white-space: nowrap;
    padding: 10px 20px;
    border: 0px solid #000;
    width: 94px;
    height: 24px;
    float: right;
    background-color: #1c50a7;
    font-size: 14px;
    font-weight: 400;
    font-family: Noto Sans S Chinese !important;
    line-height: 1.7;
    text-align: center;
    color: #ffffff;
  }

  .headerLeft {
    margin-left: 234px;
  }

  .headerRight {
    margin-left: 357px;
  }

  .headerMin {
    font-size: 18px !important;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #333333;
  }

  .headerMax {
    font-size: 24px !important;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #333333;
  }

  .closes {
    background-image: url("../assets/closeone.png");
    background-size: 32px;
    height: 32px;
    width: 32px;
  }

  .closes:hover {
    background-image: url("../assets/closetwo.png");
  }

  /deep/ .el-input__inner {
    height: 44px !important;
    font-size: 16px;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
    border-radius: 3px;
  }

  /deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #fbafaf !important;
  }

  /deep/ .el-form-item__error {
    font-size: 14px;
    color: rgba(223, 37, 37, 1);
  }

  /deep/ .el-form-item {
    margin-bottom: 21px;
  }

  .login_container {
    min-width: 948px !important;
    height: 501px !important;;
    width: 948px !important;
    background-color: #feffff;
  }

  .login_box {
    width: 615px;
    height: 501px;
    background-color: #ffffff;
    border-radius: 3px;
    position: absolute;
    left: 35%;
    /*top: 20%;*/
    box-shadow: 0 0 10px #dddddd;

    .image_box {
      position: absolute;
      transform: translate(-100%);
      background-color: #ffffff;
      border-radius: 3px;
      box-shadow: 0 0 1px #dddddd;
      width: 333px;
      height: 501px;

      img {
        width: 100%;
        height: 501px;
      }
    }

    .login_button {
      font-family: Noto Sans S Chinese !important;

      .el-button {
        font-family: Noto Sans S Chinese !important;
        position: absolute;
        width: 100%;
        background-color: #1c4fa8;
        height: 48px;
        font-size: 20px;
      }
    }

    .header {
      font-size: 22px;
      margin-left: 49%;
      transform: translate(-30%);
      margin-top: 45px;

      span {
        margin: 0;
        font-size: 22px;
        font-family: Noto Sans S Chinese;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        cursor: pointer;
      }
    }

    .login_form {
      width: 100%;
      position: absolute;
      padding-left: 15.448%;
      padding-right: 15.448%;
      box-sizing: border-box;
    }
  }
</style>
